import { render, staticRenderFns } from "./LocationCatalogueItem.vue?vue&type=template&id=275fe0a5&scoped=true&"
import script from "./LocationCatalogueItem.vue?vue&type=script&lang=ts&"
export * from "./LocationCatalogueItem.vue?vue&type=script&lang=ts&"
import style0 from "./LocationCatalogueItem.vue?vue&type=style&index=0&id=275fe0a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275fe0a5",
  null
  
)

export default component.exports